import { render, staticRenderFns } from "./SupplierTypeForm.vue?vue&type=template&id=91a6479a"
import script from "./SupplierTypeForm.vue?vue&type=script&lang=js"
export * from "./SupplierTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports